var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DC43FBE1-39BF-4291-BE29-578F859DF4A3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.3,0 L17.7,0 C17.8656854,-3.04359188e-17 18,0.134314575 18,0.3 L18,2.7 C18,2.86568542 17.8656854,3 17.7,3 L5.3,3 C5.13431458,3 5,2.86568542 5,2.7 L5,0.3 C5,0.134314575 5.13431458,-1.36097535e-16 5.3,-1.66533454e-16 Z M5.3,5 L17.7,5 C17.8656854,5 18,5.13431458 18,5.3 L18,7.7 C18,7.86568542 17.8656854,8 17.7,8 L5.3,8 C5.13431458,8 5,7.86568542 5,7.7 L5,5.3 C5,5.13431458 5.13431458,5 5.3,5 Z M5.3,10 L17.7,10 C17.8656854,10 18,10.1343146 18,10.3 L18,12.7 C18,12.8656854 17.8656854,13 17.7,13 L5.3,13 C5.13431458,13 5,12.8656854 5,12.7 L5,10.3 C5,10.1343146 5.13431458,10 5.3,10 Z M1.5,0 C2.32842712,-1.52179594e-16 3,0.671572875 3,1.5 C3,2.32842712 2.32842712,3 1.5,3 C0.671572875,3 1.01453063e-16,2.32842712 0,1.5 C-1.01453063e-16,0.671572875 0.671572875,1.52179594e-16 1.5,0 Z M1.5,5 C2.32842712,5 3,5.67157288 3,6.5 C3,7.32842712 2.32842712,8 1.5,8 C0.671572875,8 1.01453063e-16,7.32842712 0,6.5 C-1.01453063e-16,5.67157288 0.671572875,5 1.5,5 Z M1.5,10 C2.32842712,10 3,10.6715729 3,11.5 C3,12.3284271 2.32842712,13 1.5,13 C0.671572875,13 1.01453063e-16,12.3284271 0,11.5 C-1.01453063e-16,10.6715729 0.671572875,10 1.5,10 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "16-tasks",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16.2-UCAP-AdvisorCenter-Edit-Task",
    transform: "translate(-260.000000, -116.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16.0-UCAP-AdvisorCenter-ClientTasks-Dropdown"
  }, /*#__PURE__*/React.createElement("g", {
    id: "title",
    transform: "translate(260.000000, 112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "section-title",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/money-mind"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(3.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "ic_tasks",
    fill: "#8A8888",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Color",
    mask: "url(#mask-2)",
    fill: "#8A8888"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.000000, -6.000000)",
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTasks);
export default __webpack_public_path__ + "static/media/ic_tasks.a9384338b98149653f7cb7a17b712a32.svg";
export { ForwardRef as ReactComponent };